import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Activity, CalendarClock, MessagesSquare, Users, Sparkles, Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import CalendarBoard from "@/pages/CalendarBoard";
import CancelAlertModal from "@/components/CancelAlertModal";
import { GpsOfflineAlert } from "@/components/GpsOfflineAlert";

function KPI({ label, value, icon: Icon, accent="#E65100" }) {
  return (
    <div className="border border-border bg-white p-5 rounded-sm">
      <div className="flex items-center justify-between">
        <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold">{label}</div>
        <Icon className="w-4 h-4" style={{color: accent}} strokeWidth={1.7} />
      </div>
      <div className="mt-3 text-3xl font-['Manrope'] font-bold tracking-tight">{value}</div>
    </div>
  );
}

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [cancelAlertTrigger, setCancelAlertTrigger] = useState(0);

  async function load() {
    setStats(await api.stats());
    // v85.45 — trigger re-fetch cancel alerts tiap kali dashboard di-refresh
    setCancelAlertTrigger(t => t + 1);
  }
  useEffect(() => { load(); }, []);

  async function doSeed() {
    const r = await api.seedTechs();
    if (r.skipped) toast.info(`Sudah ada ${r.existing} teknisi`);
    else toast.success(`${r.seeded} teknisi berhasil di-seed`);
    load();
  }

  if (!stats) return <div className="text-sm text-zinc-500">Memuat…</div>;

  return (
    <div className="space-y-4" data-testid="dashboard-page">
      {/* v84.41 — Top KPI cards dihapus sesuai user request. Statistik sekarang
          hanya ada di legend bar dalam CalendarBoard (Scheduled/AI/Done/Cancel). */}
      {stats.active_technicians === 0 && (
        <div className="border border-dashed border-[#E65100]/40 bg-[#E65100]/5 rounded-sm p-5 flex items-center gap-4">
          <Sparkles className="w-5 h-5 text-[#E65100]" />
          <div className="flex-1">
            <div className="font-semibold text-[#E65100]">Belum ada teknisi</div>
            <div className="text-sm text-zinc-600">Isi 9 teknisi Anda di menu <b>Teknisi</b> atau klik tombol di sebelah untuk seed contoh data.</div>
          </div>
          <Button data-testid="seed-technicians-btn" onClick={doSeed} className="bg-[#E65100] hover:bg-[#F57C00] rounded-sm">Seed 9 Teknisi Contoh</Button>
        </div>
      )}
      <GpsOfflineAlert />
      <CalendarBoard />
      <CancelAlertModal trigger={cancelAlertTrigger} />
    </div>
  );
}

